export default __webpack_public_path__ + "static/media/mazda.d58fec54.svg";